import { Project } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';
import { Utils } from '@qality/common-utils';

import API from './API';

type Settings = {
  settings: {
    enabled: boolean;
    isPluginEnabled: boolean;
  };
};

export default {
  async getAllAdministeredProjects(params: {
    includeSettingsProperty: boolean;
  }): Promise<
    Array<
      Omit<Project, 'isAppVisibleInAllIssues' | 'isPluginEnabled'> & Settings
    >
  > {
    const url = [
      StorageOfUniqueServices.get('APIConstants').URL_PROJECTS_ADMINISTERED,
      `?includeSettingsProperty=${params.includeSettingsProperty}`,
    ].join('');

    return API.request(url).then((response) => {
      return JSON.parse(response.body);
    });
  },

  async hasAdministeredProject(): Promise<boolean> {
    const allAdministeredProjects = await this.getAllAdministeredProjects();
    return !Utils.isNilOrEmpty(allAdministeredProjects);
  },
};
